const homePage = {
  "home.navigation.career.title": "Carrera",
  "home.navigation.career.subtitle": "Continúa tu viaje",
  "home.navigation.challenges.title": "Desafíos",
  "home.navigation.challenges.subtitle": "Prepárate",
  "home.navigation.practice.title": "Práctica",
  "home.navigation.practice.subtitle": "Mejora tu juego",
  "home.navigation.matchplay.title": "Modo Partido",
  "home.navigation.matchplay.subtitle": "Modo de Entrenamiento con IA",
  "home.navigation.locked": "Completa el Bootcamp para desbloquear",
  "home.section.latest-challenges.title": "Últimos Desafíos",
  "home.navigation.guides.title": "Guías",
  "bootcamp.home.title": "Entrenamiento Bootcamp",
  "bootcamp.home.description": "Completa cada sesión para construir tus fundamentos y desbloquear la experiencia completa de entrenamiento.",
};

const bootcampWelcome = {
  "bootcamp.welcome.title": "¡Bienvenido a Be Your Best! ⚽",
  "bootcamp.welcome.description":
    "Estás en el Bootcamp — tu punto de partida. Completa estas sesiones breves para conocer nuestras métricas, calibrar tu BYB IQ inicial y desbloquear el entrenamiento completo.",
  "bootcamp.welcome.start": "Comenzar Bootcamp",
};

const bootcampFinished = {
  "bootcamp.finished.title": "Bootcamp completado",
  "bootcamp.finished.description": "Continúa tu camino explorando todos los modos de juego.",
};

export const vrHome = {
  ...homePage,
  ...bootcampWelcome,
  ...bootcampFinished,
};
